module.exports = __webpack_public_path__ + "img/question-base-active.9b3a61be.png";